export default "__VITE_ASSET__e79da003__"